module.exports = __webpack_public_path__ + "img/pdf.059aee69.png";